import {Breakpoints, styled} from '@vw-marketing/us-components';

export const StyledNoResultsSectionContainer = styled.div`
  #highlight-container {
    opacity: 0;
    width: 0;
    height: 0;
    top: 0;
    left: 0;
    position: fixed;
    visibility: hidden;
    border-radius: 5px;
    box-shadow: 0 0 0 9999px rgb(0, 0, 0, 0.15);
    transition: visibility 1s, opacity 0.5s linear;
  }

  .details-dealer {
    width: 100%;
    flex-direction: column;
    border: solid 1px #cfcfcf;
    border-radius: 2%;
    padding: 20px 6% 30px;

    .details-dealer-header {
      margin-bottom: 10px;
    }

    .details-dealer-info-wrapper {
      border: none;
      padding: unset;
      padding-top: 20px;

      .details-dealer-name > div {
        font-size: 16px;
      }

      .details-dealer-location div {
        font-size: 14px;
      }

      .details-dealer-phone-site div {
        font-size: 14px;
      }

      .details-dealer-contact-button {
        width: 100%;

        div {
          color: #fff;
        }
      }
    }

    @media (min-width: ${Breakpoints.b560}px) {
      border: none;
      padding: unset;
      flex-direction: row-reverse;
      justify-content: space-between;
      height: 273px;

      .details-dealer-header {
        display: none;
      }

      .details-maps-image {
        width: 51%;
        overflow: hidden;
        height: inherit;

        img {
          height: inherit;
          object-fit: fill;
        }
      }

      .details-dealer-info-wrapper {
        height: inherit;
      }

      .details-dealer-info-wrapper {
        width: 49%;
        border: solid 1px #cfcfcf;
        border-right: none;
        border-top-left-radius: 2%;
        border-bottom-left-radius: 2%;
        border-bottom-right-radius: 0;
        padding: 20px 6% 30px;

        .details-dealer-name-miles {
          flex-direction: column;

          .details-dealer-name {
            width: 100%;
          }
        }

        .details-dealer-contact-button {
          margin-left: 0;
          width: 75%;
        }
      }
    }

    @media (min-width: ${Breakpoints.b960}px) {
      width: 81%;

      .details-maps-image {
        width: 53%;
      }

      .details-dealer-info-wrapper {
        width: 47%;
      }
    }

    @media (min-width: ${Breakpoints.b1280}px) {
      width: 61%;

      .details-maps-image {
        width: 49%;
      }

      .details-dealer-info-wrapper {
        width: 51%;
      }
    }

    @media (min-width: ${Breakpoints.b1920}px) {
      width: 46.5%;
    }

    @media (min-width: ${Breakpoints.b2560}px) {
      width: 35%;
    }
  }
`;

export const StyledDealerHeader = styled.div`
  @media (min-width: ${Breakpoints.b560}px) {
    margin-bottom: 50px;
  }
`;

export const StyledNoResultsHeader: any = styled.div`
  margin-bottom: 35px;

  & > :nth-child(2) {
    width: 80%;
    margin-bottom: 15px;
  }

  @media (min-width: ${Breakpoints.b560}px) {
    margin-bottom: 43px;
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    margin-bottom: 50px;
  }
`;

export const StyledRefineLink: any = styled.div`
  cursor: pointer;

  svg {
    margin-right: 5px;
  }

  a {
    border: none;
  }
`;
